import * as yup from "yup";
import { DateFilterValue } from "../../constants";

export const downloadActivityDataReportFormSchema: yup.AnyObjectSchema =
    yup.object({
        type: yup.string().required("Please select a report type"),
        dateRange: yup.string().required("Please select a date range"),
    });

export type DownloadActivityDataReportFormValues = {
    type: string;
    dateRange: DateFilterValue;
};

export const defaultDownloadActivityDataReportFormValues: DownloadActivityDataReportFormValues =
    {
        type: "",
        dateRange: "this-month",
    };

export type DownloadActivityDataReportFormValuesWithFormattedDates = {
    type: string;
    fromDate: string;
    toDate: string;
};
